import { render, staticRenderFns } from "./InviteAdmin.vue?vue&type=template&id=610d6ac4&scoped=true&"
import script from "./InviteAdmin.vue?vue&type=script&lang=js&"
export * from "./InviteAdmin.vue?vue&type=script&lang=js&"
import style0 from "./InviteAdmin.vue?vue&type=style&index=0&id=610d6ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d6ac4",
  null
  
)

export default component.exports